'use strict';

bbw.service.chat.ClientFactory = Class({

    _rpcClient: undefined,
    $q: undefined,
    _wsUrl: undefined,

    $inject: ['rpcClient', '$q'],

    construct: function(rpcClient, $q) {
        this._rpcClient = rpcClient;
        this.$q = $q;
        this._wsUrl = bbw.configuration.chat.ws_url;
    },

    create: function() {
        var ws = new bbw.WebSocket(this.$q, this._wsUrl);
        var wsClient = new bbw.service.chat.WebSocketClient(this.$q, ws);
        return new bbw.service.chat.Client(this.$q, this._rpcClient, wsClient);
    }

});
